"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleCalendar = void 0;
const react_1 = __importDefault(require("react"));
const SimpleCalendar = ({ size, color }) => {
    return (react_1.default.createElement("svg", { width: size, height: size, viewBox: "0 0 50 50", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("g", null,
            react_1.default.createElement("path", { d: "M44.3226 5.32946H40.625V0H34.375V5.32946H15.625V0H9.37501V5.32946H5.68201C2.5285 5.32946 0.0284195 7.72771 0.0284195 10.6589L0 43.75C0 46.6812 3.09649 50 6.25 50H43.75C46.8751 50 50 46.6812 50 43.75V10.6589C50 7.72771 47.4477 5.32946 44.3226 5.32946ZM43.75 43.75H6.25001V18.75H43.75V43.75Z", fill: color || '#25CFBB' }))));
};
exports.SimpleCalendar = SimpleCalendar;
